module.exports = __webpack_public_path__ + "static/img/11.1740ac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/11.png
// module id = 09wh
// module chunks = 1